import { render, staticRenderFns } from "./CoockiesSubs.vue?vue&type=template&id=07cfb316&"
import script from "./CoockiesSubs.vue?vue&type=script&lang=js&"
export * from "./CoockiesSubs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\CA5\\PhpstormProjects\\te-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('07cfb316', component.options)
    } else {
      api.reload('07cfb316', component.options)
    }
    module.hot.accept("./CoockiesSubs.vue?vue&type=template&id=07cfb316&", function () {
      api.rerender('07cfb316', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/Partials/CoockiesSubs.vue"
export default component.exports